import script from "./LegalModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalModal.vue?vue&type=script&setup=true&lang=js"

import "./LegalModal.vue?vue&type=style&index=0&id=5296d996&scoped=true&lang=css"
import "./LegalModal.vue?vue&type=style&index=1&id=5296d996&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5296d996"]])

export default __exports__